import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs1 from "./page_us/Solution-US-1/SectionUs1.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
    useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Film Solaire Maroc | Anti-Chaleur & Protection UV – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Film solaire pour vitrage au Maroc avec UNIK SYSTEM : réduction de chaleur, protection UV et amélioration du confort thermique pour maisons, bureaux et commerces."
  );

  setMeta(
    "keywords",
    "film solaire maroc, film anti chaleur vitrage maroc, protection UV fenetre maroc, film teinté maroc, film vitre anti chaleur maroc, film solaire casablanca, UNIK SYSTEM film solaire"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/film-solaire-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Film Solaire Maroc – Anti-Chaleur & UV | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Réduisez la chaleur et protégez vos espaces avec des films solaires performants."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/4Protection%20solaire%20architecturale%20UNIK%20SYSTEM%20avec%20brise-soleil%20ext%C3%A9rieur%20design%20moderne%20(5).587e1ef5bd1e4bf3569c.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/film-solaire-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Film Solaire Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solution efficace contre la chaleur et les UV pour vitrage."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/4Protection%20solaire%20architecturale%20UNIK%20SYSTEM%20avec%20brise-soleil%20ext%C3%A9rieur%20design%20moderne%20(5).587e1ef5bd1e4bf3569c.webp"
  );

  // ========= SCHEMA (SERVICE THERMIQUE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en film solaire et protection thermique pour vitrage au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Films Solaires",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Film Anti-Chaleur Vitrage"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Film Protection UV Fenêtre"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-film-solaire");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-film-solaire";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi un film solaire ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est un film appliqué sur le vitrage pour réduire la chaleur et filtrer les rayons UV."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Réduction thermique, protection UV, confort intérieur et économie d’énergie."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Maisons, bureaux, commerces et vitrines exposées au soleil."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-film-solaire");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-film-solaire";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs1/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;